import { render, staticRenderFns } from "./AnswerInfoModal.vue?vue&type=template&id=59e1e550&scoped=true&"
import script from "./AnswerInfoModal.vue?vue&type=script&lang=ts&"
export * from "./AnswerInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerInfoModal.vue?vue&type=style&index=0&id=59e1e550&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1e550",
  null
  
)

export default component.exports